import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=183586c7&scoped=true&"
import script from "./ResetPassword.vue?vue&type=script&lang=ts&"
export * from "./ResetPassword.vue?vue&type=script&lang=ts&"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=183586c7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183586c7",
  null
  
)

export default component.exports